import React from 'react';
import {t} from '@lingui/core/macro';

import {MonitorSectionTitle} from 'entities/monitor';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';
import PortIncidents from 'features/port/ui/PortIncident/PortIncidents/PortIncidents';
import {usePortMonitorIncidents} from 'features/port/model/usePortMonitorIncidents';
import {getPortMonitorName, IPortMonitorAddressSource} from 'features/port/lib/portMonitorHelper';

import styles from './PortMonitorIncidents.module.scss';

interface IPortMonitorIncidentsProps {
    portMonitorId: string,
    monitor?: IPortMonitorAddressSource,
}

const PortMonitorIncidents: React.FC<IPortMonitorIncidentsProps> = ({portMonitorId, monitor}) => {
    const {pagination, isLoading, isEmptyList, timezone, setPage} = usePortMonitorIncidents(portMonitorId);

    return (
        <TableBox className={styles.section}>
            <MonitorSectionTitle
                title={t`Инциденты`}
                name={monitor && getPortMonitorName(monitor)}
            />

            <PortIncidents
                pagination={pagination}
                isLoading={isLoading}
                tzString={timezone}
                hideMonitor
                setPage={setPage}
            />
            {isEmptyList && <PlugNoIncidents/>}
        </TableBox>
    );
};

export default PortMonitorIncidents;
